'use strict';

angular.module('ringbaPortal.services').factory('utils', utils);

function utils(
  _,
  $anchorScroll,
  $filter,
  $location,
  $log,
  $q,
  toaster,
  angularDebugInfoEnabled
) {
  'ngInject';

  const _getObjectKeys = typeof Object.keys === 'function'
    ? Object.keys
    : function(o) {
      const names = [];
      for (const property in o) {
        if (Object.prototype.hasOwnProperty.call(o, property)) {
          names.push(property);
        }
      }
      return names;
    };

  const service = {
    getChildObject: getChildObject,
    applyFilter: applyFilter,
    errorHandler: errorHandler,
    escapeJquerySelector: escapeJquerySelector,
    scrollToElementId: scrollToElementId,
    isInViewport: isInViewport,
    readImage: readImage,
    capFirstLetter: capFirstLetter,
    capFirstNLetters: capFirstNLetters,
    getObjectKeys: _getObjectKeys,
    readFileContent: readFileContent,
    getTimeDisplay: getTimeDisplay,
    rejectPromiseOnAPIError: rejectPromiseOnAPIError,
  };

  return service;

  function getChildObject(obj, path) {
    if (!obj) { return; }
    let temp = obj;
    _.forEach(path, function (p) {
      if (temp) {
        temp = temp[p];
      }
    });
    return temp;
  }

  function applyFilter(data, filterName, filterOption) {
    return $filter('applyFilter')(data, filterName, filterOption);
  }

  function errorHandler(error) {
    let message = 'Operation failed: an error has occurred';
    try {
      if (error && error.data) {
        if (error.data.modelState && error.data.modelState[''][0]) {
          message = error.data.modelState[''][0];
        } else if (error.data.errors && Array.isArray(error.data.errors) && typeof error.data.errors[0] === 'string') {
          message = error.data.errors[0];
        } else if (error.data.errors && typeof error.data.errors === 'object') {
          // ASP.NET Core validation format: { errors: { fieldName: [messages] } }
          const firstKey = Object.keys(error.data.errors)[0];
          if (firstKey && error.data.errors[firstKey] && error.data.errors[firstKey][0]) {
            message = error.data.errors[firstKey][0];
          }
        } else if (error.data.failReason && error.data.failReason.errorMessage) {
          message = error.data.failReason.errorMessage;
        } else if (error.data.message) {
          message = error.data.message;
        } else if (error.data.title) {
          // ASP.NET Core validation format uses 'title' instead of 'message'
          message = error.data.title;
        }
      }
      if (error && angularDebugInfoEnabled) {
        $log.error(error);
      }
    } catch (e) {
      $log.error(e);
    }
    if (typeof message !== 'string') message = 'Operation failed: an error has occurred';
    message = message.trim();
    message = message.charAt(0).toUpperCase() + message.slice(1);
    toaster.pop('error', message);
  }

  function escapeJquerySelector(selector) {
    return selector.replace(/(:|\.|\[|\]|,|=|@)/g, '\\$1');
  }

  function scrollToElementId(elementId, yOffset) {
    $anchorScroll.yOffset = yOffset || 0;
    $location.hash(elementId);
    $anchorScroll();
    $location.hash('');
    $location.replace();
    $anchorScroll.yOffset = 0;
  }

  function isInViewport(cssSelector) {
    const $element = $(cssSelector);
    if ($element.length) {
      const headerHeight = 50,
        elementTop = $element.offset().top,
        $window = $(window),
        viewportTop = $window.scrollTop(),
        viewportBottom = viewportTop + $window.height();

      return elementTop > (viewportTop + headerHeight) && elementTop < viewportBottom;
    }
    return false;
  }

  function readImage(file) {
    const deferred = $q.defer();

    if (file) {
      const fr= new FileReader();
      fr.onload = function(e) {
        deferred.resolve(e.target.result);
      };
      fr.readAsDataURL( file );
    } else {
      deferred.resolve(undefined);
    }

    return deferred.promise;
  }

  // This is mainly for normalizing keys sent sent in the API response
  // Eg. the target stats endpoint returns something like `tA0f78bb7d012a407d9b6c145b1f27adfd` as an object property
  function capFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  // This is mainly for normalizing keys sent sent in the API response
  // Eg. the target stats endpoint returns something like `tA0f78bb7d012a407d9b6c145b1f27adfd` as an object property
  // TODO: Remove the above function and replace it with this function
  function capFirstNLetters(string, character) {
    return string.slice(0, character).toLowerCase() + string.slice(character);
  }

  function readFileContent(file) {
    return $q(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function(evt) {
        resolve(evt.target.result);
      };

      reader.onerror = function() {
        reject('Error reading file');
      };

      reader.readAsText(file);
    });
  }

  /*
    When time is structured this way { hour, minute }
    returns `01:00PM` or `13:00`
  */
  function getTimeDisplay(time, isMeridian) {
    let hour = time.hour;
    let suffix = '';
    const minute = time.minute.toString().length === 1 ? '0' + time.minute : time.minute;

    if (isMeridian) {
      if (time.hour > 11) {
        hour = (time.hour - 12);
        hour = hour === 0 ? 12 : hour;
        suffix = 'PM';
      } else {
        hour = time.hour;
        suffix = 'AM';
      }
    }

    return hour + ':' + minute + suffix;
  }

  // TODO: Move this logic into interceptor. This needs full retest or selective application of the interceptor
  function rejectPromiseOnAPIError(response)
  {
    if(response && response.status == 200 && response.data && response.data.messageCode == null ){
      return $q.resolve(response);
    }
    else{
      return $q.reject(response);
    }
  }
}
